import * as React from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';

import useLocales from '../../../hooks/useLocales';
import FTRecentOperationsTable from '../list/FTRecentOperationsTable';
import {
    fetchFTVehicleOperations,
    selectFTVehicleOperations,
} from '../../../redux/slices/ftVehiclesSlice';

// Columns that only make sense for tank refills/adjustments, not vehicle fills.
const VEHICLE_HIDDEN_COLUMNS = ['newCounter', 'newLitres', 'supplier', 'guideNumber'];

FTVehicleRecentOperationsModal.propTypes = {
    passedData: PropTypes.any,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
};

export default function FTVehicleRecentOperationsModal({ passedData, open, handleClose }) {
    const dispatch = useDispatch();
    const { translate } = useLocales();
    const operations = useSelector(selectFTVehicleOperations);

    useEffect(() => {
        if (open && passedData) {
            dispatch(fetchFTVehicleOperations(passedData));
        }
    }, [dispatch, open, passedData]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" aria-labelledby="ft-vehicle-recent-operations">
            <DialogTitle id="ft-vehicle-recent-operations">
                {translate('recentOperations')}
            </DialogTitle>
            <DialogContent dividers>
                <FTRecentOperationsTable data={operations} showFuelTank hiddenColumns={VEHICLE_HIDDEN_COLUMNS} />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleClose}>
                    {translate('close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
